export default __webpack_public_path__ + "static/media/BecaMilano_Curso01_Banner_Mobile.40d497e7.jpg";